import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { webRoutes } from '../../routes/web';
import { Dropdown } from 'antd';
import { ProLayout, DefaultFooter } from '@ant-design/pro-components';
import Icon, { LogoutOutlined, KeyOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/slices/adminSlice';
import { memo, useEffect } from 'react';
import { sidebar } from './sidebar';
import { RiShieldUserFill } from 'react-icons/ri';
import { getLocations } from 'store/slices/locationSlice';
import GoogleAuthCard from '../google-auth-card';

const Layout = () => {
  const admin = useSelector((state) => state.admin);
  const { user } = useSelector((state) => state.admin);
  const { locations, loading, error } = useSelector((state) => state.location);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const filterSidebar = () => {
    if (user?.isAdmin) {
      return sidebar;
    } else if (locations?.[0]?.isReviewUser && locations?.[0]?.isAuthorized) {
      return sidebar;
    } else if (locations?.[0]?.isReviewUser && !locations?.[0]?.isAuthorized) {
      return sidebar.filter((item) => item.path !== webRoutes.authorizations);
    } else if (!locations?.[0]?.isReviewUser && locations?.[0]?.isAuthorized) {
      return sidebar.filter((item) => item.path === webRoutes.authorizations);
    }
  };

  const defaultProps = {
    title: 'RMS',
    logo: false,
    fixedHeader: false,
    fixSiderbar: true,
    // layout: CONFIG.theme.sidebarLayout,
    layout: 'side',
    route: {
      routes: filterSidebar(),
    },
  };

  const logoutAdmin = () => {
    dispatch(logout());
    navigate(webRoutes.login, {
      replace: true,
    });
  };

  const handleHeaderClick = () => {
    if (!user?.isAdmin && !locations?.[0]?.isReviewUser && locations?.[0]?.isAuthorized) {
      navigate(webRoutes.authorizations);
    } else {
      navigate(webRoutes.dashboard);
    }
  };

  useEffect(() => {
    dispatch(getLocations());
  }, [dispatch]);

  return (
    <div className="h-screen">
      <ProLayout
        {...defaultProps}
        token={{
          sider: {
            colorMenuBackground: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
            colorTextMenu: '#ffffff',
            colorTextMenuSelected: '#ffffff',
            colorBgMenuItemSelected: 'rgba(255, 255, 255, 0.2)',
            colorBgMenuItemHover: 'rgba(255, 255, 255, 0.1)',
            colorTextMenuActive: '#ffffff',
            colorBgCollapsedButton: '#764ba2',
            colorTextCollapsedButton: '#ffffff',
          },
        }}
        location={location}
        onMenuHeaderClick={handleHeaderClick}
        menuItemRender={(item, dom) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              item.path && navigate(item.path);
            }}
            href={item.path}
          >
            {dom}
          </a>
        )}
        menuFooterRender={(props) => {
          return (
            <>
              {/* Google Auth Card */}
              {!user?.isAdmin && locations?.[0]?.isReviewUser && <GoogleAuthCard collapsed={props?.collapsed} />}

              {/* User Profile Section */}
              {!props?.collapsed && (
                <div
                  style={{
                    padding: '16px',
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    background: 'rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: 'change-password',
                          icon: <KeyOutlined />,
                          label: 'Change Password',
                          onClick: () => {
                            navigate(webRoutes.change_password);
                          },
                        },
                        {
                          key: 'logout',
                          icon: <LogoutOutlined />,
                          label: 'Logout',
                          onClick: () => {
                            logoutAdmin();
                          },
                        },
                      ],
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '8px',
                        transition: 'all 0.3s',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)')}
                      onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                    >
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '8px',
                          background: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ffffff',
                        }}
                      >
                        {admin?.user?.Logo ? (
                          <img src={`${admin?.user?.Logo}`} alt="Logo" style={{ width: '100%', height: '100%', borderRadius: '8px' }} />
                        ) : (
                          <Icon component={RiShieldUserFill} style={{ fontSize: '20px' }} />
                        )}
                      </div>
                      <div style={{ flex: 1, color: '#ffffff' }}>
                        <div style={{ fontWeight: 600, fontSize: '14px' }}>{admin?.user?.Name || 'Admin'}</div>
                        <div style={{ fontSize: '12px', opacity: 0.8 }}>View Profile</div>
                      </div>
                    </div>
                  </Dropdown>
                </div>
              )}
            </>
          );
        }}
        footerRender={() => <DefaultFooter copyright="2024 Copyright, All Right Reserved, Made by RMS ❤️" />}
      >
        <Outlet />
      </ProLayout>
    </div>
  );
};

export default memo(Layout);
